import Schema from "AppReact/schema";
import { dropdownIcon } from "types";

export default {
  selectedIcon: Schema("string", "primitive-nullable", { defaultValue: null }),
  icons: Schema(dropdownIcon, "array", { defaultValue: [] }),
  isOpen: Schema("boolean", "primitive", { defaultValue: false }),
  label: Schema('string', 'primitive-nullable', { defaultValue: null }),
  searchVal: Schema('string', 'primitive', { defaultValue: '' }),
  isReadonly: Schema("boolean", "primitive", { defaultValue: false }),
  placeholder: Schema('string', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  tooltipText: Schema('string', 'primitive-nullable', { defaultValue: null }),
};
